import operations from '../../operations'

var common = {

  // 登陆成功后初始化系统信息 函数调用链
  initAfterLogin: [
    // {
    //   // 申请Android系统文件读写权限（移到下载文件/打开文件的时候校验）
    //   id: operations.eRequestPermissions,
    //   funcName: operations.eRequestPermissions,
    //   setParams: null,
    //   params: {}
    // },
    {
      // APK版本升级检查
      id: operations.eCheckAPKUpdate,
      funcName: operations.eCheckAPKUpdate,
      setParams: null,
      params: {}
    },
    {
      // 获取登录用户信息
      id: operations.eFetchUserInfo,
      funcName: operations.eFetchUserInfo,
      setParams: null,
      params: {}
    },
    {
      // 根据登录用户的角色信息创建底部导航栏
      id: operations.eCreateBottomsByRoles,
      funcName: operations.eCreateBottomsByRoles,
      setParams: null,
      params: {}
    },
    // {
    //   // 获取消息总数以显示
    //   id: operations.eFetchMsgForBoxBadge,
    //   funcName: operations.eFetchMsgForBoxBadge,
    //   setParams: null,
    //   params: {}
    // },
    // {
    //   // 设置用户权限
    //   id: operations.eMapRightsFromRoles,
    //   funcName: operations.eMapRightsFromRoles,
    //   setParams: null,
    //   params: {}
    // },
    {
      // 根据用户跳转页面
      id: operations.eSelectPageByRole,
      funcName: operations.eSelectPageByRole,
      setParams: null,
      params: {}
    },
    {
      // 打开第三方预览文件申请的文件
      id: operations.eEdsFileView,
      funcName: operations.eEdsFileView,
      setParams: null,
      params: {}
    },
    {
      // 初始化极光推送服务
      id: operations.eInitJPush,
      funcName: operations.eInitJPush,
      setParams: null,
      params: {}
    },
    {
      // 设置极光推送别名
      id: operations.eSetJPushAlias,
      funcName: operations.eSetJPushAlias,
      setParams: null,
      params: {}
    },
    {
      // 设置极光推送标签
      id: operations.eSetJPushTags,
      funcName: operations.eSetJPushTags,
      setParams: null,
      params: {}
    },
    {
      // 收到极光消息回调函数
      id: operations.eSetRecieveNotificationInAndroidCallback,
      funcName: operations.eSetRecieveNotificationInAndroidCallback,
      setParams: null,
      params: {}
    },
    {
      // 收到极光消息回调函数
      id: operations.eSetRecieveMessageInAndroidCallback,
      funcName: operations.eSetRecieveMessageInAndroidCallback,
      setParams: null,
      params: {}
    },
    //设置定时器（用于微信小程序、PC端H5新消息的主动拉取）
    {
      id: operations.eSetTimer,
      funcName: operations.eSetTimer,
      setParams: null,
      params: {}
    },
    // {
    //   // 获取文件Token
    //   id: operations.eFetchFSToken,
    //   funcName: operations.eFetchFSToken,
    //   setParams: null,
    //   params: {}
    // },
    // {
    //   // 获取语音Token
    //   id: operations.eFetchTTSToken,
    //   funcName: operations.eFetchTTSToken,
    //   setParams: null,
    //   params: {}
    // },
  ],

  // 刷新用户Token 函数调用链
  refreshToken: [
    {
      // 用旧Tokey和新租户刷新Token
      id: operations.eRefreshToken,
      funcName: operations.eRefreshToken,
      setParams: null,
      params: {
        tid: ''
      }
    },
    // {
    //   // 申请Android系统文件读写权限（移到下载文件/打开文件的时候校验）
    //   id: operations.eRequestPermissions,
    //   funcName: operations.eRequestPermissions,
    //   setParams: null,
    //   params: {}
    // },
    {
      // APK版本升级检查
      id: operations.eCheckAPKUpdate,
      funcName: operations.eCheckAPKUpdate,
      setParams: null,
      params: {}
    },
    {
      // 获取登录用户信息
      id: operations.eFetchUserInfo,
      funcName: operations.eFetchUserInfo,
      setParams: null,
      params: {}
    },
    {
      // 根据登录用户的角色信息创建底部导航栏
      id: operations.eCreateBottomsByRoles,
      funcName: operations.eCreateBottomsByRoles,
      setParams: null,
      params: {}
    },
    // {
    //   // 获取消息总数以显示
    //   id: operations.eFetchMsgForBoxBadge,
    //   funcName: operations.eFetchMsgForBoxBadge,
    //   setParams: null,
    //   params: {}
    // },
    // {
    //   // 设置用户权限
    //   id: operations.eMapRightsFromRoles,
    //   funcName: operations.eMapRightsFromRoles,
    //   setParams: null,
    //   params: {}
    // },
    {
      // 根据用户跳转页面
      id: operations.eSelectPageByRole,
      funcName: operations.eSelectPageByRole,
      setParams: null,
      params: {}
    },
    {
      // 打开第三方预览文件申请的文件
      id: operations.eEdsFileView,
      funcName: operations.eEdsFileView,
      setParams: null,
      params: {}
    },
    {
      // 初始化极光推送服务
      id: operations.eInitJPush,
      funcName: operations.eInitJPush,
      setParams: null,
      params: {}
    },
    {
      // 设置极光推送别名
      id: operations.eSetJPushAlias,
      funcName: operations.eSetJPushAlias,
      setParams: null,
      params: {}
    },
    {
      // 设置极光推送标签
      id: operations.eSetJPushTags,
      funcName: operations.eSetJPushTags,
      setParams: null,
      params: {}
    },
    {
      // 收到极光消息回调函数
      id: operations.eSetRecieveNotificationInAndroidCallback,
      funcName: operations.eSetRecieveNotificationInAndroidCallback,
      setParams: null,
      params: {}
    },
    {
      // 收到极光消息回调函数
      id: operations.eSetRecieveMessageInAndroidCallback,
      funcName: operations.eSetRecieveMessageInAndroidCallback,
      setParams: null,
      params: {}
    },
    {
      // 设置定时器（用于微信小程序、PC端H5新消息的主动拉取）
      id: operations.eSetTimer,
      funcName: operations.eSetTimer,
      setParams: null,
      params: {}
    },
    // {
    //   // 获取文件Token
    //   id: operations.eFetchFSToken,
    //   funcName: operations.eFetchFSToken,
    //   setParams: null,
    //   params: {}
    // },
    // {
    //   // 获取语音Token
    //   id: operations.eFetchTTSToken,
    //   funcName: operations.eFetchTTSToken,
    //   setParams: null,
    //   params: {}
    // },
  ],

  // 获取文件Token
  fetchFSToken: [
    {
      // 获取文件Token
      id: operations.eFetchFSToken,
      funcName: operations.eFetchFSToken,
      setParams: null,
      params: {}
    }
  ],

  logout: [
    {
      id: operations.eLogout,
      funcName: operations.eLogout,
      setParams: null,
      params: {}
    },
    {
      // 删除极光推送别名
      id: operations.eDeleteJPushAlias,
      funcName: operations.eDeleteJPushAlias,
      setParams: null,
      params: {}
    },
  ],
}

export default common
